import getAPIPath from '../modules/api-location';

window.assignSeasonPlanService = function(clubId, teamId, startDate, endDate, age, trainingTimes, matchDay, successFn) {
  const item = {};
  item.club_id = clubId;
  item.team_id = teamId;
  item.start_date = startDate; // "12/01/2016"
  item.end_date = endDate;
  item.age = age; // 6
  item.training_times = trainingTimes; // [(day: '4', time: '19:00'), (day: '5', time: '18:30')]
  item.match_day = matchDay; // '5'

  return $.ajax({
    url: `${getAPIPath}commandapi/seasonplan`,
    type: 'post',
    data: JSON.stringify(item),
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};

window.deleteSeasonPlanService = function(clubId, teamId, successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/season-plan?team_id=${teamId}&club_id=${clubId}`,
    type: 'delete',
    success: successFn,
    async: true,
    xhrFields: {
      withCredentials: true,
    },

  });
};



// WEBPACK FOOTER //
// ./library/js/services/seasonplan.service.js